var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M18,14 C18,13.448 18.448,13 19,13 C19.552,13 20,13.448 20,14 L20,19.503 C20,20.883 18.88,22 17.497,22 L2.503,22 C1.12,22 0,20.881 0,19.497 L0,4.503 C0,3.122 1.118,2 2.497,2 L8,2 C8.552,2 9,2.448 9,3 C9,3.552 8.552,4 8,4 L2.497,4 C2.224,4 2,4.225 2,4.503 L2,19.497 C2,19.776 2.224,20 2.503,20 L17.497,20 C17.777,20 18,19.777 18,19.503 L18,14 Z M18.586,2 L14,2 C13.448,2 13,1.552 13,1 C13,0.448 13.448,0 14,0 L21,0 C21.552,0 22,0.448 22,1 L22,8 C22,8.552 21.552,9 21,9 C20.448,9 20,8.552 20,8 L20,3.414 L11.707,11.707 C11.317,12.098 10.683,12.098 10.293,11.707 C9.902,11.317 9.902,10.683 10.293,10.293 L18.586,2 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "24x24/File_text"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icon",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportWhite);
export default __webpack_public_path__ + "static/media/Export_White.720f46000d1ccd2db475f4e0db250d2c.svg";
export { ForwardRef as ReactComponent };